import type {Result, UseCase} from 'framework';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MeasurementEntry} from '../../domain/measurement-entry';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export type GetMeasurementSessionInput = {
  readonly measuredOn: string;
};

export class GetMeasurementSession implements UseCase<
  [GetMeasurementSessionInput],
  readonly MeasurementEntry[]
> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(
    input: GetMeasurementSessionInput,
  ): Promise<Result<readonly MeasurementEntry[], BodyMeasurementsError>> {
    return this.repository.getSession(input.measuredOn);
  }
}
